@let contract = singleContract();
@if (contract) {
  <div class="contract-picker__single">
    <rs-web-icon [icon]="contract.type | contractIcon" [size]="12"></rs-web-icon>
    <span class="contract-picker__name">{{ contract | contractName: true }}</span>
    @if (unreadContractIds().includes(contract.id)) {
      <span class="contract-picker__unread" aria-hidden="true"></span>
    }
  </div>
} @else {
  <im-select
    valueKey="id"
    [label]="'contracts.contract_picker_l' | translate"
    [options]="contracts()"
    [ngModel]="contractId()"
    (ngModelChange)="contractId.set($event)"
  >
    <ng-template let-item>
      <span>{{ item | contractName: true }}</span>
      @if (unreadContractIds().includes(item.id)) {
        <span class="contract-picker__unread" aria-hidden="true"></span>
      }
    </ng-template>
  </im-select>
  <!-- Hints at unread options while the dropdown is closed. -->
  @if (hasUnreadContracts()) {
    <span class="contract-picker__unread contract-picker__unread--closed" aria-hidden="true"></span>
  }
}
